import PropTypes from "prop-types";

import React from "react";

// import { withRouter, matchPath } from "react-router";
// ^^ A Link element for our custom history router.



import "./style.scss";

class TextField extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fieldHeight: 0,
    };

    this.vars = {
      //
    };

    this.elRefs = {
      field: null,
    };
  }

  componentDidMount() {
    // this.timerID = setInterval(() => this.tick(), 1000);

    this.init();
  }

  componentWillUnmount() {
    // clearInterval(this.timerID);
  }

  componentDidUpdate(prevProps) {
    var Z = this;
    /* if (this.props.currentRoute !== prevProps.currentRoute) {
            Z.loadPage();
        } */
  }

  init = () => {
    const Z = this;

    Z.initFieldValue();
  };

  initFieldValue = () => {
    const Z = this;

    if (Z.props.updateFormValue != null) {
      // var fieldRequired = false;
      // if (Z.props.required == true) fieldRequired = true;
      Z.props.updateFormValue({
        fieldName: Z.props.name,
        fieldValue: "",
        fieldType: "TextField",
        fieldRequired: Z.props.required,
      });
    }
  };

  updateFieldValue = (event) => {
    const Z = this;

    let newValue = event.target.value;

    if (Z.props.updateFormValue != null) {
      Z.props.updateFormValue(
        {
          fieldName: Z.props.name,
          fieldValue: newValue,
          fieldType: "TextField",
          fieldRequired: Z.props.required,
        },
        () => {
          Z.adjustTextareaHeight();
        }
      );
    }
  };

  adjustTextareaHeight = () => {
    const Z = this;

    if (Z.props.multi == true) {
      let contentHeight = Z.elRefs.field.scrollHeight;
      // let paddingTop = Number(Z.elRefs.field.style["padding-top"]);
      let paddingTop = parseFloat(
        window.getComputedStyle(Z.elRefs.field).getPropertyValue("padding-top")
      );
      let paddingBottom = parseFloat(
        window
          .getComputedStyle(Z.elRefs.field)
          .getPropertyValue("padding-bottom")
      );

      var newHeight = contentHeight - paddingTop - paddingBottom;


      Z.setState({
        fieldHeight: newHeight,
      });
    }
  };

  render() {
    var Z = this;

    return (
      <div
        className={`TextField ${Z.props.multi ? "multi" : ""} ${
          Z.props.formErrors[Z.props.name] != null &&
          Z.props.formErrors[Z.props.name] != false
            ? "error"
            : ""
        }`}
      >
        <div
          className={`placeholder ${
            Z.props.formValues[Z.props.name] != "" && !Z.props.multi
              ? "floating"
              : ""
          }`}
        >
          {Z.props.placeholder}
        </div>
        {Z.props.multi ? (
          <textarea
            ref={(el) => (Z.elRefs.field = el)}
            name={Z.props.name}
            value={Z.props.formValues[Z.props.name] || ""}
            onChange={Z.updateFieldValue}
            style={{
              height: Z.state.fieldHeight
                ? `${Z.state.fieldHeight}px`
                : "1.2em",
            }}
          ></textarea>
        ) : (
          <input
            type="text"
            ref={(el) => (Z.elRefs.field = el)}
            name={Z.props.name}
            value={Z.props.formValues[Z.props.name] || ""}
            onChange={Z.updateFieldValue}
          />
        )}
        {/* <div>Errors: {JSON.stringify(Z.props.formErrors)}</div> */}
        <div className={`field-error`}>
          {Z.props.formErrors[Z.props.name] == true
            ? "This field is required."
            : `${Z.props.formErrors[Z.props.name]}`}
        </div>
      </div>
    );
  }
}

TextField.propTypes = {
  name: PropTypes.string,
  placeholder: PropTypes.string,
  formValues: PropTypes.object,
  formErrors: PropTypes.object,
  updateFormValue: PropTypes.func,
  multi: PropTypes.bool,
  required: PropTypes.any,
};

export default TextField;
